export const luzmoEmbedContainerClass = 'luzmo-embed-container';
